<template>
  <b-row>
    <b-col>
      <hr/>
      <h5>
        {{ trans('vimeo_urls') }}
        <small class="text-muted" :title="trans('vimeo_url_about')" v-b-tooltip.hover>
          <i class="fa fa-fw fa-info-circle"></i>
        </small>
      </h5>
      <b-alert v-if="!!privacySettingsMessage" variant="danger" show>
        {{ privacySettingsMessage }}
      </b-alert>

      <b-tabs pills content-class="mt-3">
        <b-tab :title="trans('vimeo_urls')" lazy>
          <vimeo-urls-table
            v-if="video"
            :organization="organization"
            :video="video"
            :vimeo_user="vimeo_user"
          />
        </b-tab>
        <b-tab :title="trans('vimeo_sidebar_text')" lazy>
          <b-form-group>
            <ckeditor
              id="ckeditor"
              v-model="microsite_sidebar_text"
              :editor="editor"
              :config="editorConfig"
            />
          </b-form-group>
          <p v-if="busy">
            <i class="fa fa-fw fa-circle-notch fa-spin"></i>
            {{ trans('please_wait') }}
          </p>
          <p v-if="error" class="text-danger">
            {{ error }}
          </p>
          <b-button variant="primary" @click="save">
            {{ trans('save') }}
          </b-button>
        </b-tab>
        <template v-slot:tabs-end>
          <b-nav-item :href="`/org/8/vimeo/${video_id}`" target="_vimeo_preview" role="presentation" class="ml-auto">
            {{ trans('preview') }}
            <i class="fa fa-fw fa-external-link-alt"></i>
          </b-nav-item>
        </template>
      </b-tabs>
    </b-col>
  </b-row>
</template>

<script>
  import VimeoUrlsTable from './VimeoUrlsTable'
  import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor'
  import Essentials from '@ckeditor/ckeditor5-essentials/src/essentials'
  import Heading from '@ckeditor/ckeditor5-heading/src/heading'
  import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold'
  import Underline from '@ckeditor/ckeditor5-basic-styles/src/underline'
  import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic'
  import Font from '@ckeditor/ckeditor5-font/src/font'
  import Link from '@ckeditor/ckeditor5-link/src/link'
  import List from '@ckeditor/ckeditor5-list/src/list'
  import Indent from '@ckeditor/ckeditor5-indent/src/indent'
  import IndentBlock from '@ckeditor/ckeditor5-indent/src/indentblock'
  import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment'
  import BlockQuote from '@ckeditor/ckeditor5-block-quote/src/blockquote'
  import CKEditor from '@ckeditor/ckeditor5-vue2'

  export default {
    props: {
      organization: Object,
      video_id: String,
      vimeo_user: Object,
    },
    components: {
      VimeoUrlsTable,
      ckeditor: CKEditor.component,
    },
    data() {
      return {
        trans: trans,
        error: null,
        busy: false,
        video: null,
        microsite_sidebar_text: null,
        editor: ClassicEditor,
        editorConfig: {
          language: window.lang,
          plugins: [
            Heading,
            Essentials,
            Bold,
            Italic,
            Underline,
            Font,
            Link,
            List,
            Indent,
            IndentBlock,
            Alignment,
            BlockQuote,
          ],
          toolbar: [
            'heading',
            'bold',
            'italic',
            'underline',
            'fontFamily',
            'fontSize',
            'fontColor',
            'link',
            'blockQuote',
            '|',
            'alignment',
            'bulletedList',
            'numberedList',
            'indent',
            'outdent',
            '|',
            'undo',
            'redo',
          ],
          fontSize: _.ckeditorFontSize,
          fontColor: {
            colors: _.ckeditorColors(this.organization),
            columns: 5
          },
          link: {
            addTargetToExternalLinks: true
          },
        },
      }
    },
    computed: {
      privacySettingsMessage() {
        if (!this.video) return null
        let messages = []
        if (this.video.can_embed != 'whitelist' || (this.video.whitelist_domains || []).indexOf('activitymessenger.com') === -1)
          messages.push(trans('vimeo_privacy_whitelist'))
        return messages.join(' ')
      },
    },
    methods: {
      save() {
        this.error = null
        this.busy = true
        let url = `/organization/${this.organization.id}/media/vimeo/${this.video_id}/settings`
        return axios.patch(url, {
          microsite_sidebar_text: this.microsite_sidebar_text,
        })
        .then(response => {
          this.busy = false
          this.video.am_settings = response.data
          this.microsite_sidebar_text = this.video.am_settings.microsite_sidebar_text
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
      fetch() {
        let url = `/organization/${this.organization.id}/media/vimeo/${this.video_id}`
        return axios.get(url)
        .then(response => {
          this.video = response.data
          this.microsite_sidebar_text = this.video.am_settings ? this.video.am_settings.microsite_sidebar_text : null
        })
        .catch(error => {
          _.toastError(this, _.errorFromAjax(error))
        })
      },
    },
    mounted() {
      window.vimeoSettings = this
      this.fetch()
    },
  }
</script>